import { GridApi } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { ProductType, Manufacturer } from 'app/model/entities/entity-model';
import { AgFns, ISortModel } from 'app/shared/ag-fns';
import { UniAgFns } from 'app/shared/uni-ag-fns';
import { DbQueryService } from 'app/shared/db-query.service';
import { EntityFinderDialog, EntityFinderParams } from 'app/shared/entity-finder.dialog';
import { UtilFns } from 'app/shared/util-fns';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';


@Component({
    template: EntityFinderDialog.HTML,
    standalone: false
})
export class ManufacturerFinderDialogComponent extends EntityFinderDialog<Manufacturer, EntityFinderParams> {

  targetProductType: ProductType;
  targetManufacturer: Manufacturer;

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<EntityFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    Object.assign(this.config, {
      width: '800px',
      rowModelType: 'serverSide'
    });
    if (config.header == null) {
      config.header =`Select Manufacturer`;
    }
  }
  
  override async initDatasource() {
    let q = this.dbQueryService.createManufacturerQuery();
    const ds = AgFns.buildDatasource(() => q);
    return ds;
  }
  
  override getColDefsAndSortModel() {
    const colDefs = [
      { headerName: 'Manufacturer', field: 'name', filter: 'agTextColumnFilter' },
      { ...UniAgFns.getActiveStatusColDef('activeStatus.name'), filter: 'agTextColumnFilter' },
      { headerName: 'Id', field: 'id', filter: 'agNumberColumnFilter' },
    ];

    const sortModel = [
      { colId: 'manufacturer.name', sort: 'asc' },

    ] as ISortModel;
    return [colDefs, sortModel] as const;
  }
  
  override async processGrid(gridApi: GridApi) {
    if (this.targetProductType == null) {
      return;
    }
        
    gridApi.setColumnFilterModel('productType.manufacturer.name', {
      filterType: 'text',
      type: 'equals',
      filter: this.targetProductType.manufacturer.name
    });
    gridApi.setColumnFilterModel('productType.style', {
      filterType: 'text',
      type: 'equals',
      filter: this.targetProductType.style
    });

    gridApi.onFilterChanged();
    await UtilFns.wait(0)
  }

  
}
